module.exports = {"130683001":"祁州药市街道","130683100":"祁州镇","130683101":"伍仁桥镇","130683102":"石佛镇","130683103":"郑章镇","130683104":"大五女镇","130683105":"西佛落镇","130683200":"明官店乡","130683201":"南娄底乡","130683202":"西安国城乡","130683204":"北段村乡","130683400":"现代中药工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130683.json
// module id = 158
// module chunks = 0